<template>
  <div :bg-variant="bgvariant" :text-variant="textvariant" :class="classlist">
    <div class="card-body d-flex align-items-end">
      <div>
        <i v-if="fa" :class="faicon" aria-hidden="true"></i>
        <b-link :href="url" @click="onClick"
          ><h4 class="card-title mb-1">{{ title }} &nbsp;<i class="fa fa-caret-right" aria-hidden="true"></i></h4
        ></b-link>
        <p class="card-text">{{ text }} {{ classlist }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/card.scss";

export default {
  name: "card-link",

  props: {
    id: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
    },
    bgvariant: {
      type: String,
      default: "",
    },
    fa: {
      type: String,
      default: "",
    },
    textvariant: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },

    classes: {
      type: String,
      default: "",
    },
  },
  computed: {
    faicon() {
      if (this.fa) {
        return {
          [`icon fa fa-${this.fa}`]: true,
        };
      }
      return "";
    },
    classlist() {
      let str = "card ";
      str += this.classes ? " " + this.classes + " " : "";
      str += this.bgvariant ? " bg-" + this.bgvariant + " " : "";
      str += this.textvariant ? " text-" + this.textvariant + " " : "";
      return str;
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
};
</script>
